﻿import router from './utils/router'
import './natalia.main.css'
import initNavbar from './components/navbar'
import initPreloader from './components/preloader'

router({
  becomeCustomers: import('./pages/become-customers')
})

initNavbar()
initPreloader()
